import SliderInterface from 'components/Slider/interfaces/SliderInterface';
import Slider from 'components/Slider/Slider';

export default class SliderTrustpilot extends Slider {
  static configDefault: SliderInterface = {
    selector: '.js-sliderTrustpilot',
    options: {
      slidesPerView: 'auto',
      spaceBetween: 20,
      on: {
        slideChangeTransitionStart: () => {
          Slider.slideChangeTransitionStart({
            containerSlider: document.querySelector(
              '.js-sliderTrustpilot .c-slider__container'
            ),
            nextSlide: document.querySelector(
              '.js-sliderTrustpilot .swiper-slide-next'
            ),
            currentSlide: document.querySelector(
              '.js-sliderTrustpilot .c-slider__slide--active'
            ),
            lastSecondSlideIndex: document.querySelector(
              '.js-sliderTrustpilot .c-slider__slide:nth-last-child(1)'
            ),
            secondSlideIndex: document.querySelector(
              '.js-sliderTrustpilot .c-slider__slide:nth-child(2)'
            ),
          });
        },
      },
    },
  };

  constructor(sliderConfig: SliderInterface) {
    super(SliderTrustpilot.sliderTrustpilotConfig(sliderConfig));

    this.create();
  }

  /*
   * Merge default config and new config
   * */
  private static sliderTrustpilotConfig(
    config: SliderInterface
  ): SliderInterface {
    return { ...SliderTrustpilot.configDefault, ...config };
  }
}
